<template>
  <div class="teacher-typer-page">
    <shared-header />
    <div class="add-sample-wrap">
      <el-card class="add-sample-card" shadow="hover">
        <template #header>
          <span class="card-title">添加打字样本</span>
          <p class="card-desc">
            将范文或练习段落登记到样本库，提交后写入数据库，供后续布置打字练习引用。
          </p>
        </template>

        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="100px"
          label-position="left"
          class="add-sample-form"
        >
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" placeholder="样本标题" @keydown.stop />
          </el-form-item>
          <el-form-item label="正文" prop="text">
            <el-input
              v-model="form.text"
              type="textarea"
              :rows="10"
              placeholder="完整英文段落，即打字练习对照文本"
              @keydown.stop
            />
          </el-form-item>
          <el-form-item label="分值" prop="score">
            <el-input-number v-model="form.score" :min="0" :max="100" :step="0.5" :precision="2" />
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-input v-model="form.type" placeholder="例如：toefl、custom" @keydown.stop />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submitLoading" @click="onSubmit">提交</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import SharedHeader from '../../shared/SharedHeader.vue'

export default {
  name: 'TyperAddSample',
  components: { SharedHeader },
  data() {
    return {
      submitLoading: false,
      form: {
        id: 0,
        title: '',
        text: '',
        score: 0,
        type: ''
      },
      rules: {
        title: [{ required: true, message: '请填写标题', trigger: 'blur' }],
        text: [{ required: true, message: '请填写正文', trigger: 'blur' }],
        type: [{ required: true, message: '请填写类型', trigger: 'blur' }]
      }
    }
  },
  methods: {
    buildPayload() {
      return {
        id: 0,
        title: (this.form.title || '').trim(),
        text: (this.form.text || '').trim(),
        score: Number(this.form.score) || 0,
        type: (this.form.type || '').trim()
      }
    },
    onSubmit() {
      this.$refs.formRef?.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const payload = this.buildPayload()
        this.$store
          .dispatch('TyperSample/addSample', payload)
          .then((res) => {
            const newId = res.data
            ElMessage.success(
              typeof newId === 'number' && newId > 0
                ? `已保存，样本编号 ${newId}`
                : '已保存'
            )
            this.resetForm()
          })
          .catch((err) => {
            const d = err.response?.data
            const msg =
              (typeof d === 'string' && d) ||
              d?.message ||
              d?.title ||
              err.message ||
              '提交失败，请稍后重试'
            ElMessage.error(String(msg))
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    resetForm() {
      this.$refs.formRef?.resetFields()
      this.form.id = 0
      this.form.score = 0
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-typer-page {
  text-align: left;
}

.add-sample-wrap {
  max-width: 720px;
  margin: 24px auto;
  padding: 0 16px;
}

.add-sample-card {
  border-radius: 8px;
}

.card-title {
  font-size: 1.15rem;
  font-weight: 600;
}

.card-desc {
  margin: 8px 0 0;
  font-size: 13px;
  color: var(--el-text-color-secondary);
  line-height: 1.5;
}

.add-sample-form {
  margin-top: 8px;
}
</style>
